import { TimeZoneType } from "../../constants/timezones"
import { createHolidayChecker, createWeekendChecker } from "../../calendar-settings/utils/date"

type ComposeDateFilterOptions = {
  filterDate?: (date: Date) => boolean
  weekendDays?: DayOfWeek[]
  timeZone?: TimeZoneType
  fixedHolidays?: string[]
  recurringHolidays?: string[]
}

export const composeDateFilter = ({
  filterDate = () => true, // default filter that allows all dates
  weekendDays = [],
  fixedHolidays = [],
  recurringHolidays = [],
  timeZone = "UTC",
}: ComposeDateFilterOptions) => {
  const hasWeekendsOrHolidays = weekendDays.length > 0 || fixedHolidays.length > 0 || recurringHolidays.length > 0
  if (!hasWeekendsOrHolidays) return filterDate

  const isHoliday = createHolidayChecker({ fixedHolidays, recurringHolidays, timeZone })
  const isWeekend = createWeekendChecker({ weekendDays, timeZone })

  return (date: Date) => {
    if (isHoliday(date)) return false
    if (isWeekend(date)) return false
    return filterDate(date)
  }
}
